import React, { Component } from 'react';
import {getCustomerServiceQueriesForInspection,deleteCustomerServiceQuery,createQuickComment} from '../../data/dashboard_api';
import { Button, Grid, Header, Icon, Segment,Table,Popup,Form,Input } from 'semantic-ui-react';
import AddCustomerService from './add_customer_service';
import ViewQueryDetail from './view_query_detail';
import EditQueryDetail from './edit_query_detail';
import Loader from "../universal/loader";
import moment from "moment"

class CustomerServiceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            CSData: [],
            showAddCS: false,
            viewDetail: false,
            viewDetailQuery:null,
            quickAddComment:"",
            quickAddSeverity:0,
            loadingQuickComment:false
        }
    }

    componentDidMount() {
     this.getCustomerService().then(() => {this.setState({ isFetching: false })})
    }
   
    getCustomerService = async () => {
        this.setState({ isFetching: true, showAddCS: false, action: null,actionQuery:null})
     const response = await getCustomerServiceQueriesForInspection(this.props.inspectionId)
     this.setState({ CSData: response,isFetching:false })
    }

    quickAddCS = () =>{
        this.setState({loadingQuickComment:true})
        const formData = new FormData();
        formData.append("comment", this.state.quickAddComment)
        formData.append("severity",this.state.quickAddSeverity);  
        formData.append("inspection_id",this.props.inspectionId)
        createQuickComment(formData).then(()=>{ this.setState({quickAddComment:"",quickAddSeverity:0,loadingQuickComment:false});this.getCustomerService()  })

    }

    deleteCustomerServiceQuery = async (query_id) => {
        this.setState({ isDeleting: true })
        await deleteCustomerServiceQuery(query_id).then(() => { this.setState({ isDeleting: false });this.getCustomerService() })        
    }
    viewDetail = async ( query ) => {
    this.setState({action:"view", actionQuery:query})
    }
    editDetail = async ( query ) => {
        this.setState({action:"edit", actionQuery:query})
        }
   
    render() {

        const status = {
            "pending": 'Pending',
            "awaiting_admin_review": 'Awaiting Admin Review',
            "awaiting_clerk_reply": 'Awaiting Clerk Reply',
            "closed": 'Closed'
        };
        return (this.state.isFetching ? <div style={{ height: "100%" }}><Loader contain={true}></Loader></div> : <div>
            {this.state.isDeleting && <Loader></Loader>}
            <Header size="large" content={`Customer Service - ${this.props.propertyAddress}`} textAlign="center" />
            <Segment>
                {this.state.action &&
                    <Segment>
                        <Segment>
                            <Button primary icon="left arrow" content="Go Back" onClick={() => { this.getCustomerService() }}></Button>{this.state.action === "view"?  this.props.userRole ==="admin" && <Button content="Edit Query" icon="edit" onClick={() => { this.editDetail(this.state.actionQuery) }}></Button>:<Button icon="eye" content="View Only" onClick={() => { this.viewDetail(this.state.actionQuery) }}></Button>}
                              <Button icon="list" content="Report Viewer" onClick={() =>{ this.state.actionQuery.inspection.online_viewer_link && window.open(this.state.actionQuery.inspection.online_viewer_link, "_blank")}}></Button>
                            <Button icon="download" content="Report Download" onClick={()=>this.props.handleDownload()}></Button></Segment>
                        {this.state.action === "view" && <ViewQueryDetail refreshData={this.getCustomerService} userRole={this.props.userRole} query={this.state.actionQuery}></ViewQueryDetail>}
                        {this.state.action === "edit" && <EditQueryDetail refreshData={this.getCustomerService} userRole={this.props.userRole}query={this.state.actionQuery}></EditQueryDetail>}
                    </Segment>}    
            {this.state.CSData.length > 0 && !this.state.action && <Table compact striped  >
                    <Table.Header>
                        <Table.Row textAlign="center">
                                <Table.HeaderCell>Date Submitted</Table.HeaderCell>
                                <Table.HeaderCell>Type</Table.HeaderCell>
                                <Table.HeaderCell>Querier Name</Table.HeaderCell>
                                <Table.HeaderCell>Querier Relation</Table.HeaderCell>
                                <Table.HeaderCell>Querier Email</Table.HeaderCell>
                                <Table.HeaderCell>Email Validated</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                {this.props.userRole === "admin"  ? <Table.HeaderCell>Action</Table.HeaderCell>:null}
                            </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.CSData && this.state.CSData.map((query) => {
                            return (
                                <Table.Row textAlign="center" key={query.id}>
                            <Table.Cell>{moment(query.created_at).format("DD-MM-YYYY")}</Table.Cell>
                                    {/* //<Table.Cell>{query.query_comment.split("\n").map((value, index) => { return (<React.Fragment key={index}>{value}<br /></React.Fragment>); })}</Table.Cell> */}
                                    <Table.Cell style={{ textTransform: "capitalize" }}>{query.query_type}</Table.Cell>
                                    <Table.Cell>{query.querier_name}</Table.Cell>
                                    <Table.Cell>{query.querier_relation}</Table.Cell>
                                    <Table.Cell>{query.validation_email}</Table.Cell>
                                    <Table.Cell>{query.email_validated? "Yes" : "No"}</Table.Cell>
                                    <Table.Cell style={{ textTransform: "capitalize" }}>{status[query.status]}</Table.Cell>
                                    <Table.Cell collapsing>
                                        <Button compact size="mini" basic content='View'color="green" onClick={() => { this.viewDetail(query) }} />
                                        {this.props.userRole === "admin" && <Button compact size="mini" basic color="blue" content='Edit' onClick={() => { this.editDetail(query) }} />}
                                        {this.props.userRole === "admin" && <Popup trigger={<Button compact basic color='red' size="mini" content='Delete' />}
                                            content={<React.Fragment><Header as="h4">Delete message?</Header><Button color='green' content='Confirm message delete' onClick={() => { this.deleteCustomerServiceQuery(query.id) }} /></React.Fragment>}
                                            on='click'
                                            position='top right' />}
                                    </Table.Cell> 
                                </Table.Row>)
                        })}
                    </Table.Body>
                </Table>}
                {!this.state.action && this.props.userRole != "clerk" && <Segment textAlign="center">
                        {this.state.showAddCS ? <AddCustomerService inspectionId={this.props.inspectionId} reportId={this.props.reportId} refreshData={this.getCustomerService} /> : <div><Button icon primary onClick={() => { this.setState({ showAddCS: true }) }}><Icon name="edit"/>Add Customer Service</Button>
                        {this.props.userRole == "admin" &&<Popup      style={{ minWidth: "600px" }} wide="very" on="click" trigger={
                                <Button icon color="red" >  <Icon name="lightning" /> Quick Add Comment </Button>}
                            content={
                                <Form>
                                    <Form.Field><label>Comment</label>
                                        <Form.TextArea value={this.state.quickAddComment} onChange={e => this.setState({ quickAddComment: e.target.value })}  placeholder="Enter comment"
                                        />
                                    </Form.Field>
                                    <Form.Field> <label>Severity</label>
                                     <Button.Group>
                                        {[0, 1, 2, 3].map(severity => (  <Button  key={severity} color={this.state.quickAddSeverity === severity ? "blue":""} onClick={() => this.setState({  quickAddSeverity: severity })}>  {severity}   </Button>  ))}   </Button.Group>
                                    </Form.Field>

                                    <Button loading={this.state.loadingQuickComment}disabled={this.state.quickAddComment.length < 5} primary fluid onClick={() => this.quickAddCS()}>
                                        Submit
                                    </Button>
                                </Form>
                            }
                        />}
                        </div>}
                    </Segment>}
            </Segment></div>
        );
    }
}

export default CustomerServiceList;


// WEBPACK FOOTER //
// ./src/views/inspection/customer_service_list.js